<bom-svg-definitions></bom-svg-definitions>
<div
  *ngIf="appConfig?.showEnvironmentBanner"
  id="environmentIdentifier"
  [title]="appConfig.environmentDescription"
  [ngStyle]="{ 'background-color': appConfig.environmentBannerColor }"
>
  <span>{{ appConfig.environmentLong }}</span>
</div>
<ng-container *ngIf="!(isMobileSigning$ | async); else mobileView">
  <header class="header" role="banner">
    <!-- 1A: Portal header -->
    <div class="portal-header">
      <div class="container portal-header-inner">
        <a
          [routerLink]="['/']"
          title="Byg og Miljø"
          aria-label="logo link"
          class="logo"
          [class.bom-icon-logo]="isNeutralCss$ | async"
        ></a>
        <button
          class="button button-secondary button-menu-open js-menu-open ml-auto"
          aria-haspopup="menu"
          title="Åben mobil menu"
        >
          {{ 'Menu' | tekstresource }}
        </button>
        <!-- 1B: Portal header: info + actions -->
        <div class="portal-info">
          <button
            *ngIf="!authService.user"
            (click)="login()"
            class="button button-secondary test-login-button no-print"
            role="button"
          >
            {{ 'LogInd' | tekstresource }}
          </button>
          <div *ngIf="authService.user" class="d-flex align-items-center pr-4">
            <p class="user mr-4">
              <b class="username test-username">
                <span *ngIf="userInfo$ | async as userInfo; else noUserInfo">{{
                  userInfo.displayName
                }}</span>
                <ng-template #noUserInfo>
                  <span>{{ authService.user.profile.name }}</span>
                </ng-template>
              </b>
            </p>
            <button
              (click)="logout()"
              class="button button-secondary test-logout-button no-print"
              role="button"
            >
              {{ 'LogUd' | tekstresource }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 2A: Solution header -->
    <div class="solution-header no-print">
      <div class="container solution-header-inner">
        <div class="solution-heading content">
          <a [routerLink]="['/']" title="Hjem" aria-label="logo link">
            Byg og Miljø
            <span *ngIf="projekt$ | async as projekt">
              - {{ projekt.titel ? projekt.titel : ('NytProjekt.Titel' | tekstresource) }}</span
            >
          </a>
        </div>
        <!-- 2B: Solution header: Authority name + text -->
        <div class="solution-info">
          <router-outlet name="contact"></router-outlet>
          <bom-contact></bom-contact>
        </div>
      </div>
    </div>

    <div class="overlay no-print"></div>

    <nav role="navigation" class="nav no-print">
      <!-- collapsible -->
      <button class="button button-tertiary button-menu-close js-menu-close" title="Luk mobil menu">
        <svg class="icon-svg"><use xlink:href="#close"></use></svg> Luk
      </button>
      <!-- 3: Main navigation -->
      <div class="navbar navbar-primary">
        <!-- 3A: Main navigation -->
        <div class="navbar-inner container">
          <ul class="nav-primary">
            <li routerLinkActive="current" [routerLinkActiveOptions]="{ exact: true }">
              <a class="nav-link" [routerLink]="['/']">
                <span>{{ 'Forside' | tekstresource }}</span>
              </a>
            </li>
            <li routerLinkActive="current">
              <a class="nav-link" [routerLink]="['/projekter', 'nyt', 'ikke-gemt']">
                <span>{{ 'StartNytProjekt' | tekstresource }}</span>
              </a>
              <a class="nav-link" [routerLink]="['/projekter', 'nyt']" style="display: none"></a>
            </li>
            <li *ngIf="authService.user" routerLinkActive="current">
              <a class="nav-link" [routerLink]="['/projekter', 'mine']">
                <span>{{ 'MineProjekter.Titel' | tekstresource }}</span>
              </a>
              <a
                class="nav-link"
                [routerLink]="['/projekter', 'fortsaet']"
                style="display: none"
              ></a>
            </li>
            <ng-container *ngIf="userInfo$ | async as userInfo">
              <li
                *ngIf="userInfo.isCompanyAdministrator || userInfo.employeeCanReadAllProjects"
                routerLinkActive="current"
              >
                <a class="nav-link" [routerLink]="['/projekter', 'virksomhed']">
                  <span>{{ 'VirksomhedsProjekter.Titel' | tekstresource }}</span>
                </a>
              </li>
              <li *ngIf="userInfo.isCompanyAdministrator" routerLinkActive="current">
                <a class="nav-link" [routerLink]="['/virksomhed', 'opsaetning']">
                  <span>{{ 'UserMenuCompanySetup' | tekstresource }}</span>
                </a>
              </li>
              <li *ngIf="userInfo.hasFuldmagter" routerLinkActive="current">
                <a class="nav-link" [routerLink]="['/skiftbruger']">
                  <span>{{ 'Fuldmagt.SkiftBruger' | tekstresource }}</span>
                </a>
              </li>
            </ng-container>
            <li routerLinkActive="current">
              <a
                class="nav-link"
                [routerLink]="['/hjaelp']"
                bomTooltip
                [tutorialSequenceId]="Tutorials.sequenceIdFoerstekrav"
                [step]="3"
                placement="bottom"
              >
                <span>{{ 'Hjælp' | tekstresource }}</span>
              </a>
            </li>
          </ul>
          <div class="profile header-link"><bom-save-indicator></bom-save-indicator></div>
          <ul class="nav-primary ml-auto">
            <li
              *ngIf="authService.user"
              routerLinkActive="current"
              [routerLinkActiveOptions]="{ exact: false }"
            >
              <a class="nav-link" [routerLink]="['/profil']">
                <span>
                  {{ 'MinProfil' | tekstresource }}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      class="primary"
                      d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                    />
                  </svg>
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <!-- 3: Main navigation end -->

      <div class="portal-info-mobile">
        <div *ngIf="authService.user" class="d-flex align-items-center">
          <p class="user">
            <b>{{ authService.user.profile.name }}</b>
          </p>
          <a href="#" class="button button-secondary button-signout">
            {{ 'LogUd' | tekstresource }}
          </a>
        </div>
      </div>

      <div class="solution-info-mobile">
        <p><b>[Københavns Kommune]</b></p>
        <p>
          <a
            [routerLink]="['/kontakt']"
            class="button button-quaternary button-contact pr-3"
            data-micromodal-trigger="modal-contact"
          >
            {{ 'Kontakt' | tekstresource
            }}<svg class="icon-svg"><use xlink:href="#menu-right"></use></svg>
          </a>
        </p>
      </div>
    </nav>
    <bom-link-to-publicweb></bom-link-to-publicweb>
    <bom-operating-status></bom-operating-status>
  </header>
</ng-container>
<div class="container px-3 py-5" [class.frontpage-container]="isFrontpage$ | async">
  <router-outlet></router-outlet>
</div>
<footer *ngIf="showFooter$ | async" class="no-print">
  <div class="footer">
    <div class="container">
      <div class="row">
        <div class="col-4 footer-col">
          <a
            [routerLink]="['/']"
            title="Byg og Miljø"
            aria-label="logo link"
            class="logo bom-icon-logo logo-footer"
          >
          </a>
        </div>

        <div class="col-4 footer-col">
          <div class="align-text-left">
            <h1 class="mb-4 smaller-header" title="Links" aria-label="Links">Links</h1>
            <ul class="mt-0 nobullet-list">
              <li>
                <a class="function-link" [routerLink]="['/hjaelp']">Hjælp</a>
              </li>
              <li>
                <a class="function-link" [routerLink]="['/hjaelp', 'hvordan']">
                  Hvordan bruger jeg Byg og Miljø?
                </a>
              </li>
              <li>
                <a
                  class="function-link"
                  [routerLink]="['/hjaelp', 'myndighedsinformation', 'cookiepolitik']"
                >
                  Cookiepolitik
                </a>
              </li>
              <li>
                <a class="function-link" href="/WAS"> Tilgængelighedserklæring </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-4 footer-col">
          <div class="align-text-left">
            <h1 class="mb-4 smaller-header" title="Kontakt" aria-label="Kontakt">Kontakt</h1>
            <div class="contact-wrapper">
              <bom-default-contact title="Kontaktinformation"></bom-default-contact>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
<bom-notification></bom-notification>
<bom-timeout></bom-timeout>
<bom-gdpr-modal></bom-gdpr-modal>

<ng-template #mobileView>
  <header class="header" role="banner">
    <div class="portal-header">
      <div class="container portal-header-inner">
        <a
          title="Byg og Miljø"
          class="logo"
          [class.bom-icon-logo]="isNeutralCss$ | async"
          aria-label="logo-link"
        ></a>
      </div>
    </div>
  </header>
</ng-template>
